<ng-template #modalLG let-modal>
    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class="close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="add-product-modal-scroll">
        <div class="modal-body p-0" tabindex="0" ngbAutofocus (scroll)="onAddProductModalScroll()">
            <div class="text-center mb-0">
                <h5 style="font-size: 24px">Ajout produit</h5>
                <p>Veuillez remplir tous ces champs nécessaires.</p>
            </div>
            <!-- ==================== TYPE DU PRODUIT + ligne nom / réf. (même largeur que les cartes) ==================== -->
            <div class="add-product-type-stack">
            <label class="form-label size15">Type du produit <span class="text-danger">*</span></label>
            <div class="form-section rounded d-flex w-100">
                <div class="option-card bordered pl-0"
                     [ngClass]="{ 'selected': product.type === 'matériel',  'is-invalid': dataError.type }"
                     (click)="selectType('matériel')">
                    <div class="card-content d-flex flex-column align-items-center justify-content-center">
                        <div class="icon-title-container d-flex align-items-center justify-content-center">
                            <i data-feather="package" [size]="26" class="mb-1"></i>
                            <span style="font-size: 15px">Matériel</span>
                        </div>
                        <label class="container">
                            <input type="radio"
                                   name="productType"
                                   value="matériel"
                                   [(ngModel)]="product.type"
                                   (change)="selectType(product.type)"
                                   class="form-check-input">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div *ngIf="dataError.type" class="invalid-feedback d-block mt-2 ml-0 p-0"
                         style="text-align: justify;">
                        {{ dataError.type }}
                    </div>
                </div>

                <div class="option-card bordered"
                     [ngClass]="{ 'selected': product.type === 'service', 'is-invalid': dataError.type }"
                     (click)="selectType('service')">
                    <div class="card-content d-flex flex-column align-items-center justify-content-center">
                        <div class="icon-title-container d-flex align-items-center justify-content-center">
                            <i data-feather="hard-drive" [size]="26" class="mb-1"></i>
                            <span>Service</span>
                        </div>
                        <label class="container">
                            <input type="radio"
                                   name="productType"
                                   value="service"
                                   [(ngModel)]="product.type"
                                   (change)="selectType(product.type)"
                                   class="form-check-input">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>

                <div class="option-card bordered"
                     [ngClass]="{ 'selected': product.type === 'financier', 'is-invalid': dataError.type }"
                     (click)="selectType('financier')">
                    <div class="card-content d-flex flex-column align-items-center justify-content-center">
                        <div class="icon-title-container d-flex align-items-center justify-content-center">
                            <i data-feather="dollar-sign" [size]="26" class="mb-1"></i>
                            <span style="font-size: 15px">Financier</span>
                        </div>
                        <label class="container">
                            <input type="radio"
                                   name="productType"
                                   value="financier"
                                   [(ngModel)]="product.type"
                                   (change)="selectType(product.type)"
                                   class="form-check-input">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
            <!-- ==================== NOM / CODE-BARRES / RÉFS (largeur égale) ==================== -->
            <div
                class="add-product-name-ref-row"
                [class.add-product-name-ref-row--service]="isServiceLikeProduct()"
                [class.add-product-name-ref-row--materiel]="product.type === 'matériel'"
            >
                <div class="add-product-field add-product-field--nom">
                    <label class="form-label size15">Nom du produit <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Entrez Nom Produit"
                        [(ngModel)]="product.nom"
                        name="productName"
                        [ngClass]="{ 'is-invalid': !!dataError.nom }"
                        (blur)="onIdentityFieldBlur('nom')"
                        (ngModelChange)="onIdentityFieldChange('nom')"
                        required
                    />
                    <div *ngIf="dataError.nom" class="invalid-feedback d-block">{{ dataError.nom }}</div>
                </div>
                <div class="add-product-field add-product-field--code-barre" *ngIf="product.type === 'matériel'">
                    <label class="form-label size15">Code-barres <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Entrez le code-barres"
                        [(ngModel)]="product.code_barre"
                        name="productCodeBarre"
                        [ngClass]="{ 'is-invalid': !!dataError.codeBarre }"
                        (blur)="onIdentityFieldBlur('codeBarre')"
                        (ngModelChange)="onIdentityFieldChange('codeBarre')"
                        required
                    />
                    <div *ngIf="dataError.codeBarre" class="invalid-feedback d-block">{{ dataError.codeBarre }}</div>
                </div>
                <div class="add-product-field add-product-field--ref-interne" *ngIf="product.type">
                    <label class="form-label size15">Référence interne <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Entrez la référence interne"
                        [(ngModel)]="product.ref_interne"
                        name="productRefInterne"
                        [ngClass]="{ 'is-invalid': !!dataError.ref }"
                        (blur)="onIdentityFieldBlur('ref')"
                        (ngModelChange)="onIdentityFieldChange('ref')"
                        required
                    />
                    <div *ngIf="dataError.ref" class="invalid-feedback d-block">{{ dataError.ref }}</div>
                </div>
                <div class="add-product-field add-product-field--ref-fabricant" *ngIf="product.type === 'matériel'">
                    <label class="form-label size15">Référence fabricant <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Entrez votre Référence fabricant"
                        [(ngModel)]="product.ref_fabricant"
                        name="productRefFabricant"
                        [ngClass]="{ 'is-invalid': !!dataError.refFabricant }"
                        (blur)="onIdentityFieldBlur('refFabricant')"
                        (ngModelChange)="onIdentityFieldChange('refFabricant')"
                        required
                    />
                    <div *ngIf="dataError.refFabricant" class="invalid-feedback d-block">{{ dataError.refFabricant }}</div>
                </div>
            </div>
            </div>

            <!-- ==================== TVA + TAXES ==================== -->
            <div class="d-flex align-items-start tva-taxes-row" style="gap: 50px; margin-bottom: 24px;">
                <div class="flex-shrink-0">
                    <label class="form-label size15" style="color: #2F2B3DB2">TVA <span class="text-danger">*</span></label>
                    <div class="d-flex align-items-center form-check p-0" style="gap: 12px">
                        <ng-select
                            class="ng-select-custom add-product-ng-select add-product-ng-select--tva"
                            [items]="tva"
                            bindLabel="valeur"
                            bindValue="id"
                            [(ngModel)]="product.tva_id"
                            name="productTva"
                            [clearable]="false"
                            [searchable]="true"
                            placeholder="TVA"
                            notFoundText="Aucune TVA"
                            dropdownPosition="auto"
                            [ngClass]="{ 'is-invalid': dataError.tva }"
                            (ngModelChange)="clearFieldError('tva'); onTvaChange()">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item?.valeur }} %
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item?.valeur }} %
                            </ng-template>
                        </ng-select>
                    </div>
                    <div *ngIf="dataError.tva" class="invalid-feedback d-block">{{ dataError.tva }}</div>
                </div>

                <div class="taxes-column flex-grow-1">
                    <label class="form-label size15" style="color: #2F2B3DB2">Taxes</label>
                    <div class="taxes-radio" *ngIf="taxes?.length">
                        <div class="taxes-radio-row">
                            <div
                                class="form-check form-check-inline check-border"
                                *ngFor="let taxe of taxes"
                                style="margin: 0;">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    [id]="'add-product-taxe-' + taxe.id"
                                    [checked]="selectedTaxeIds.includes(taxe.id)"
                                    (change)="toggleTaxe(taxe.id, $any($event.target).checked)"
                                />
                                <label class="form-check-label small fw-medium mb-0" [for]="'add-product-taxe-' + taxe.id">
                                    {{ taxe.nom || taxe.label }} ({{ taxe.valeur }})
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ==================== PRIX DE VENTE ==================== -->
            <div >
                <label class="form-label size15">Prix de vente <span *ngIf="isPrixVenteRequired()" class="text-danger">*</span></label>
                <input
                        type="number"
                        class="form-control"
                        min="0"
                        style="width: 433px"
                        [(ngModel)]="product.prix_unitaires"
                        (input)="onPrixAchatChange(); clearFieldError('prix_unitaires')"
                        [ngClass]="{ 'is-invalid': dataError.prix_unitaires }"
                        placeholder="Entrez le prix" />

                <div class="d-flex align-items-center mt-1" style="gap: 30px;">

                        <label class="tva-box2">
                            <div>
                                <label class="container">
                                    <input type="radio"
                                           name="priceType" value="HT" [(ngModel)]="priceType" (change)="calculateFinalPrice()"
                                           class="form-check-input">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <span class="form-check-label size15">HT</span>
                        </label>

                    <span style="color: #134AD3; font-weight: 500;">{{ product.result_ht | number:'1.2-2' }} DT</span>

                    <label class="tva-box2">
                        <div>
                            <label class="container">
                                <input type="radio"
                                       name="priceType" value="TTC" [(ngModel)]="priceType" (change)="calculateFinalPrice()"
                                       class="form-check-input">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <span class="form-check-label size15" >TTC</span>
                    </label>


                    <span style="color: #134AD3; font-weight: 500;">{{ product.result_ttc | number:'1.2-2' }} DT</span>
                </div>
                <div class="d-flex" style="gap: 28px;margin-top: 24px">

                    <div class="custom-control custom-checkbox mb-1" >
                        <input type="checkbox"
                               class="custom-control-input"
                               id="afficherMontant"/>
                        <label class="custom-control-label" for="afficherMontant">Afficher les montants totaux</label>
                    </div>
                    <div class="custom-control custom-checkbox mb-1">
                        <input type="checkbox"
                               class="custom-control-input"
                               id="afficherDescription"/>
                        <label class="custom-control-label" for="afficherDescription">Afficher une courte description</label>
                    </div>

                </div>
            </div>

            <!-- ==================== BLOCS DYNAMIQUES (toujours affichés) ==================== -->
            <div class="border-dashed rounded espece-box mt-1">
                <div *ngFor="let section of allSections; let i = index">
                    <hr class="m-0" *ngIf="i > 0" style="border-bottom: 1px dashed #134AD3">

                    <!-- En-tête pliable -->
                    <div class="d-flex align-items-center justify-content-between"
                         style="width: 100%; padding: 24px 37px 24px 37px; cursor: pointer;"
                         (click)="toggleContent(section.id)">

                        <div class="d-flex align-items-center">
                            <i class="bi me-2"
                               [ngClass]="section.isContentVisible ? 'bi-chevron-down' : 'bi-chevron-right'"
                               [style.color]="section.isContentVisible ? 'rgba(19, 74, 211, 1)' : 'rgba(47, 43, 61, 0.4)'"
                               style="margin-right: 8px"
                              ></i>
                            <p class="texte-noir mb-0 fw-500">

                                <strong>
                                    <span *ngIf="section.type === 'listePrix'">Liste de prix</span>
                                    <span *ngIf="section.type === 'inf'">Information logistique</span>
                                </strong>
                            </p>
                        </div>

                        <div class="d-flex align-items-center gap-3">
                            <!-- Affichage du prix TTC pour Liste de prix -->

                            <!-- Bouton supprimer -->
                            <i class="bi bi-trash3 text-danger fs-5 cursor-pointer"
                               (click)="removeSection(i); $event.stopPropagation()"
                               title="Supprimer cette section"></i>
                        </div>
                    </div>

                    <!-- Contenu dépliable -->
                    <div *ngIf="section.isContentVisible" style="padding: 0 37px 24px 37px">

                        <!-- ==================== LISTE DE PRIX ==================== -->
                        <div *ngIf="section.type === 'listePrix'">
                            <div >


                                <div *ngFor="let price of priceLists; let i = index" class="price-block ">
                                    <!-- Liste de prix -->
                                    <div class="mt-3 " *ngIf="i >= 1 " style="border-top: 1px solid #134AD3; width: 350px"> </div>
                                    <div>

                                        <div class="price-type-row">

                                            <div class="price-type-field">
                                                <label class="form-label size13" style="width: 100px">
                                                    Type <span *ngIf="price.selectedPriceId || price.montant"
                                                               class="text-danger">*</span></label>
                                                <div class="d-flex align-items-start price-type-select-row">
                                                    <ng-select
                                                            class="ng-select-custom add-product-ng-select add-product-ng-select--price"
                                                            [items]="availablePriceLists"
                                                            bindLabel="libelle"
                                                            bindValue="id"
                                                            [(ngModel)]="price.selectedPriceId"
                                                            name="priceSelect{{ i }}"
                                                            [clearable]="true"
                                                            [searchable]="true"
                                                            placeholder="Sélectionner un type"
                                                            notFoundText="Aucune liste de prix"
                                                            dropdownPosition="auto"
                                                            [ngClass]="{ 'is-invalid': dataError.list }"
                                                            (ngModelChange)="clearFieldError('list'); onPriceSelected(i, $event)">
                                                    </ng-select>
                                                    <button class="minus-button ml-3"
                                                            *ngIf="(price.selectedPriceId || price.montant) || (priceLists.length > 1 || hasAddedPrice)"
                                                            (click)="onMinusClick(i, price)"
                                                            [disabled]="priceLists.length <= 1 && !(price.selectedPriceId || price.montant)"
                                                            title="Supprimer / Annuler"
                                                    >
                                                        <i data-feather="minus" [size]="16"></i>
                                                    </button>
                                                </div>

                                            </div>

                                            <!-- base de calcul et Règles -->
                                            <div class=" items d-flex" style="margin-bottom: 24px">
                                                <div>
                                                    <label class="mb-1 form-label size15">Base de calcul
                                                        <span *ngIf="price.selectedPriceId || price.montant"
                                                              class="text-danger">*</span></label>
                                                    <div class="form-check form-check-inline" >
                                                        <div>
                                                            <label class="container">
                                                                <input type="radio"
                                                                       id="prixpub{{ i }}"
                                                                       (input)="clearFieldError('bascul_calcul')"
                                                                       (change)="onBaseCalculChange(i)"
                                                                       name="bascul_group{{ i }}" value="prix_public"
                                                                       [(ngModel)]="price.bascul_calcul"
                                                                       [ngClass]="{ 'is-invalid': dataError.bascul_calcul }"
                                                                       class="form-check-input">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                        <label class="form-check-label size15" style="width: 100px" for="prixpub{{ i }}">Prix
                                                            publique</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <div>
                                                            <label class="container">
                                                                <input type="radio" class="form-check-input"
                                                                       (input)="clearFieldError('bascul_calcul')"
                                                                       (change)="onBaseCalculChange(i)"
                                                                       [(ngModel)]="price.bascul_calcul"
                                                                       name="bascul_group{{ i }}" value="arbitraires"
                                                                       id="arbitraire{{ i }}"/>
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                        <label class="form-check-label size15"
                                                               for="arbitraire{{ i }}">Arbitraire</label>
                                                    </div>
                                                    <div *ngIf="dataError.bascul_calcul"
                                                         class="invalid-feedback d-block">
                                                        {{ dataError.bascul_calcul }}
                                                    </div>
                                                </div>
                                                <div *ngIf="price.bascul_calcul !== 'arbitraires'">
                                                    <label class="mb-1 form-label size15">
                                                        Règles <span *ngIf="price.selectedPriceId || price.montant"
                                                                     class="text-danger">*</span></label>
                                                    <div class="form-check form-check-inline">
                                                        <div>
                                                            <label class="container">
                                                                <input type="radio" class="form-check-input" id="fix{{ i }}"
                                                                       [ngClass]="{ 'is-invalid': dataError.regle }"
                                                                       (input)="clearFieldError('regle')"
                                                                       (change)="onBaseCalculChange(i)"
                                                                       [(ngModel)]="price.regles"
                                                                       name="rule_group{{ i }}" value="fixe"/>
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                        <label class="form-check-label size15"
                                                               for="fix{{ i }}">Fixe</label>
                                                    </div>

                                                    <div class="form-check form-check-inline">
                                                        <div>
                                                            <label class="container">
                                                                <input type="radio" class="form-check-input"
                                                                       id="percent{{ i }}"
                                                                       (input)="clearFieldError('regle')"
                                                                       (change)="onBaseCalculChange(i)"
                                                                       [(ngModel)]="price.regles"
                                                                       name="rule_group{{ i }}" value="pourcentage"/>
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                        <label class="form-check-label size15" for="percent{{ i }}">Pourcentage</label>
                                                    </div>
                                                    <div *ngIf="dataError.regle" class="invalid-feedback d-block">
                                                        {{ dataError.regle }}
                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                        <div *ngIf="dataError.list" class="invalid-feedback d-block">
                                            {{ dataError.list }}
                                        </div>
                                    </div>


                                    <!-- Montant & Résultat -->
                                    <div class="d-flex items2 align-items-center "
                                         style="gap: 20px; margin-bottom: 24px;margin-top: 24px">
                                        <div class="">
                                            <label class="form-label" *ngIf=" price.regles !=='pourcentage' || price.bascul_calcul === 'arbitraires'">
                                                Montant <span *ngIf="price.selectedPriceId || price.montant "
                                                              class="text-danger">*</span>


                                            </label>
                                            <!-- Indication pour pourcentage -->
                                            <label class="form-label" *ngIf="price.regles === 'pourcentage'">
                                                Pourcentage % <span *ngIf="price.selectedPriceId || price.montant "
                                                                    class="text-danger">*</span>
                                            </label>
                                            <div class="custom-input-container">
                                                <button class="minus-button-left"
                                                        (click)="decrementAmount(i)">-
                                                </button>

                                                <input style="border-radius: 0px" type="number"
                                                       class="form-control text-center"
                                                       [ngClass]="{ 'is-invalid': dataError.montant }"
                                                       (input)="clearFieldError('montant'); calculateResults(i)"
                                                       [(ngModel)]="price.montant" name="amount-{{i}}"/>

                                                <button class="minus-button-right"
                                                        (click)="incrementAmount(i)">+
                                                </button>

                                            </div>

                                            <div *ngIf="dataError.montant" class="invalid-feedback d-block">
                                                {{ dataError.montant }}
                                            </div>
                                        </div>
                                        <div>
                                            <label class="form-label">Résultat</label>

                                            <!-- Sélecteur HT/TTC pour Arbitraire -->
                                            <div *ngIf="price.bascul_calcul === 'arbitraires'" class="row ml-0 d-flex ">
                                                <label class="tva-box">
                                                    <div>
                                                        <label class="container">
                                                            <input
                                                                    class="tva-radio"
                                                                    type="radio"
                                                                    [name]="'arbitraryPriceType' + i"
                                                                    value="HT"
                                                                    [(ngModel)]="priceType2"
                                                                    (change)="onArbitraryPriceTypeChange(i)"
                                                            />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>

                                                    <span style="font-size: 15px;align-items: center">HT</span>
                                                </label>
                                                <div class="" style="margin-top: 8px;align-items: center;height: 38px">
                                                    <span class="mx-1 size15"
                                                          style="color: #134AD3;">{{ price.result_ht | number:'1.2-2' }}
                                                        DT</span>
                                                </div>

                                                <label class="tva-box" >
                                                    <div>
                                                        <label class="container">
                                                            <input
                                                                    class="tva-radio"
                                                                    type="radio"
                                                                    [name]="'arbitraryPriceType' + i"
                                                                    value="TTC"
                                                                    [(ngModel)]="priceType2"
                                                                    (change)="onArbitraryPriceTypeChange(i)"
                                                            />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>

                                                    <span style=" font-size: 15px; align-items: center;">TTC</span>
                                                </label>
                                                <div style="margin-top: 8px;align-items: center;height: 38px">
                                                    <span class="mx-1 size15"
                                                          style="color: #134AD3; ">{{ price.result_ttc | number:'1.2-2' }}
                                                        DT</span>
                                                </div>
                                            </div>

                                            <!-- Affichage simple pour Prix Public -->
                                            <div *ngIf="price.bascul_calcul === 'prix_public'" class="d-flex " style="gap: 22px">
                                                <div class="d-flex">
                                                    <div class="result-box">{{ (price.result_ht || 0) | number:'1.2-2' }} DT</div>  <span class="ttc">HT</span>
                                                </div>
                                                <div class="d-flex">

                                                    <div class="result-box">{{ (price.result_ttc || 0) | number:'1.2-2' }} DT</div>
                                                    <span class="ttc mr-1">TTC</span>
                                                </div>

                                            </div>

                                            <!-- Affichage par défaut quand rien n'est sélectionné -->
                                            <div *ngIf="!price.bascul_calcul" class="d-flex " style="gap: 22px">
                                                <div class="d-flex">
                                                    <div class="result-box">0.00 DT</div>
                                                    <span class="ttc">TTC</span>
                                                </div>
                                                <div class="d-flex">
                                                    <div class="result-box">0.00 DT</div>
                                                    <span class="ttc mr-1">HT</span>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Bouton ajouter -->
                                <a class="text-primary " style="margin-bottom: 4px"
                                   (click)="addPriceList()"><strong>Ajouter un nouveau prix</strong></a>
                            </div>



                        </div>

                        <!-- ==================== INFORMATION LOGISTIQUE ==================== -->
                        <div *ngIf="section.type === 'inf'">
                            <div class="row g-3">
                                <ng-container *ngFor="let warehouse of warehouses; let wi = index">
                                <div class="items2 mb-2">
                                    <!-- Entrepôt -->
                                    <div class="warehouse-field">
                                        <label class="size13">Entrepôt <span class="text-danger"
                                                                             *ngIf="warehouses.length > 1 || warehouse.entrepot_id || warehouse.minimum || warehouse.maximum">*</span>
                                        </label>
                                        <ng-select
                                            class="ng-select-custom add-product-ng-select add-product-ng-select--warehouse"
                                            [items]="allEntrepot"
                                            bindLabel="nom"
                                            bindValue="id"
                                            [(ngModel)]="warehouse.entrepot_id"
                                            name="warehouse-{{wi}}"
                                            [clearable]="true"
                                            [searchable]="true"
                                            placeholder="Sélectionner un entrepôt"
                                            notFoundText="Aucun entrepôt"
                                            dropdownPosition="auto"
                                            [ngClass]="{ 'is-invalid': dataError.entrepot }"
                                            (ngModelChange)="clearFieldError('entrepot')">
                                        </ng-select>
                                        <div *ngIf="dataError.entrepot"
                                             class="invalid-feedback d-block">
                                            {{ dataError.entrepot }}
                                        </div>
                                    </div>

                                    <!-- Minimum -->
                                    <div>
                                        <label class="size13">
                                            Minimum <span class="text-danger"
                                                          *ngIf="warehouses.length > 1 || warehouse.entrepot_id || warehouse.minimum || warehouse.maximum">*</span>
                                        </label>
                                        <div class="custom-input-container">
                                            <button class="minus-button-left" (click)="decrement(wi)"
                                                    [disabled]="warehouse.minimum <= 0">-
                                            </button>
                                            <input style="border-radius: 0px"
                                                   type="number"
                                                   min="0"
                                                   class="form-control text-center"
                                                   name="minStock-{{wi}}"
                                                   [(ngModel)]="warehouse.minimum"
                                                   (keydown)="preventNegativeInput($event)"
                                                   (input)="clearFieldError('min'); ensurePositiveValue(warehouse, 'minimum')"
                                                   (blur)="ensurePositiveValue(warehouse, 'minimum')"
                                                   [ngClass]="{ 'is-invalid': dataError.min }"
                                            />

                                            <button class="minus-button-right" (click)="increment(wi)">
                                                +
                                            </button>
                                        </div>
                                        <div *ngIf="dataError.min"
                                             class="invalid-feedback d-block">
                                            {{ dataError.min }}
                                        </div>
                                    </div>

                                    <!-- Maximum -->
                                    <div>
                                        <label class="size13">
                                            Maximum <span class="text-danger"
                                                          *ngIf="warehouses.length > 1 || warehouse.entrepot_id || warehouse.minimum || warehouse.maximum">*</span>
                                        </label>
                                        <div class="custom-input-container">
                                            <button class="minus-button-left" (click)="decrementMax(wi)"
                                                    [disabled]="warehouse.maximum <= 0">-
                                            </button>
                                            <input style="border-radius: 0px"
                                                   type="number" min="0"
                                                   class="form-control text-center"
                                                   name="maxStock-{{wi}}"
                                                   [(ngModel)]="warehouse.maximum"
                                                   (input)="clearFieldError('max'); ensurePositiveValue(warehouse, 'maximum')"
                                                   (blur)="ensurePositiveValue(warehouse, 'maximum')"
                                                   [ngClass]="{ 'is-invalid': dataError.max }"
                                            />

                                            <button class="minus-button-right"
                                                    (click)="incrementMax(wi)">+
                                            </button>

                                            <button
                                                    class="minus-button ml-2"
                                                    *ngIf="(warehouse.entrepot_id || warehouse.minimum || warehouse.maximum) || warehouses.length > 1"
                                                    (click)="onWarehouseMinusClick(wi, warehouse)"
                                                    [disabled]="warehouses.length <= 1 && !(warehouse.entrepot_id || warehouse.minimum || warehouse.maximum)"
                                                    title="Supprimer / Annuler"
                                            >
                                                <i data-feather="minus" [size]="16"></i>
                                            </button>

                                        </div>
                                        <div *ngIf="dataError.max"
                                             class="invalid-feedback d-block">
                                            {{ dataError.max }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="custom-control custom-checkbox mb-1 warehouse-alert-checkbox">
                                        <input type="checkbox"
                                               class="custom-control-input"
                                               [id]="'desactiveAlerte-' + wi"
                                               [name]="'alert_' + wi"
                                               [ngModel]="!warehouse.is_active_alert"
                                               (ngModelChange)="warehouse.is_active_alert = !$event"/>
                                        <label class="custom-control-label" [attr.for]="'desactiveAlerte-' + wi">Désactiver l'alerte lorsque le stock est vide</label>
                                    </div>
                                </div>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-center" style="gap: 16px;margin-top: 24px">
                <button class="btn bGris" (click)="onClose()">Fermer</button>
                <button
                    type="button"
                    class="btn bBleu d-inline-flex align-items-center justify-content-center"
                    (click)="saveProduct()"
                    [disabled]="isLoading || isIdentityFieldsMissing()"
                >
                    <span
                        *ngIf="isLoading"
                        class="spinner-border spinner-border-sm mr-1"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    {{ isLoading ? 'Enregistrement...' : 'Valider' }}
                </button>
            </div>

        </div>
    </div>

</ng-template>


<app-croud-tva #croudTva></app-croud-tva>
<app-add-taxe #addtaxe></app-add-taxe>
